<div class="modal">
  <div class="modal-ctn">

    <div class="options">
      <div>{{ 'PRODUCT.UPDATE_MISSION_PRODUCT' | translate | uppercase }} {{ this.params.missionProduct.productName }}</div>
      <img src="assets/images/close.svg" (click)="close()"/>
    </div>

    <input type="text" [(ngModel)]="productExpectedQty">

    <div class="footer">
      <button class="text" (click)="update()" [disabled]="!isValid()">{{ 'SAVE' | translate | uppercase }}</button>
    </div>
      
  </div>
</div>